import { put } from '../helpers'

export default {
  updateLanguage(language) {
    const path = `api/update_language?language=${language}`
    return put(path)
  }
}
